import request from '@/utils/request'


// 查询师傅订单结算列表
export function listSettlement(query) {
  return request({
    url: '/master/master-settlement/list',
    method: 'get',
    params: query
  })
}

// 查询师傅订单结算分页
export function pageSettlement(query) {
  return request({
    url: '/master/master-settlement/page',
    method: 'get',
    params: query
  })
}

// 查询师傅订单结算详细
export function getSettlement(data) {
  return request({
    url: '/master/master-settlement/detail',
    method: 'get',
    params: data
  })
}

// 新增师傅订单结算
export function addSettlement(data) {
  return request({
    url: '/master/master-settlement/add',
    method: 'post',
    data: data
  })
}

// 修改师傅订单结算
export function updateSettlement(data) {
  return request({
    url: '/master/master-settlement/edit',
    method: 'post',
    data: data
  })
}

// 删除师傅订单结算
export function delSettlement(data) {
  return request({
    url: '/master/master-settlement/delete',
    method: 'post',
    data: data
  })
}
